import type { ListOrdersAdminInput } from '@repo/api-contracts';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

/**
 * 어드민 주문 목록(orderManagement.list, 주문 설계 §8-5) — 쪽·필터(기본 처리할 건)·검색어. 조건을 바꾸는 동안 이전 쪽 표를
 * 자리표시자로 유지한다. 서버가 조회 전에 관리자 접속기록을 남긴다(R22).
 */
export const useOrdersListQuery = (query: ListOrdersAdminInput) =>
  trpc.orderManagement.list.useQuery(query, { placeholderData: keepPreviousData });
